import ApiUtil from '../util/ApiUtil';
import Constants from '../constants/Constants';
import {IFeed} from '../model/feed';

const feedBaseUrl = '/api/v1/feed';

const getFeed = async (techSmithId: string, cursor: string = null): Promise<IFeed> => {
   const cursorQuery = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
   const response = await ApiUtil.executeGetWithoutCacheAsync(`${feedBaseUrl}/${techSmithId}${cursorQuery}`, [Constants.statusCodes.ok]);
   return response.data as IFeed;
};

export default {
   getFeed
};
